import React from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Button from '@/ui/components/shared/Button';
import Checkmark from '../../../../../../public/images/checkmark-yellow-black-border.svg';

export default function ConfirmationPage() {
  const t = useTranslations('CSForm');
  return (
    <div className="flex justify-center">
      <div className="max-w-[56rem] overflow-y-hidden px-6 py-15">
        <div className="mb-8 flex justify-center">
          <Image
            src={Checkmark}
            alt=""
            width={32}
            height={32}
            className="h-14 w-14 sm:h-20 sm:w-20"
          />
        </div>
        <div className="text-center">
          <h1 className="mb-8 text-xl font-bold sm:text-4xl">
            {t('confirmationPageHeader')}
            <span className="text-primary-100">!</span>
          </h1>
          <p className="mb-12 whitespace-pre-line sm:text-lg">{t('confirmationPageBody')}</p>
        </div>
        <div className="flex items-center justify-center">
          <Button className="inline-flex items-center px-3 py-2" href="https://help.nuki.io">
            {t('returnToHelpCenterButton')}
          </Button>
        </div>
      </div>
    </div>
  );
}
